var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ScreenSelect',{attrs:{"showType":false},on:{"changeTimeRange":_vm.selectTime}}),_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.tableData,"pagination":_vm.pagination,"row-key":record => record.pkId,"loading":_vm.loading,"scroll":{ x: 1200 }},on:{"change":_vm.handlePagination}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }